import { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import { CircularProgress, Alert } from "@mui/material";

import { fetchLatestBottlenecks } from "./fetchBottlenecks";
import BottlenecksMap from "./component/BottlenecksMap";

const REFRESH_INTERVAL = 1 * 60 * 1000; // 5 minutes

function Bottlenecks() {
  const [data, setData] = useState(null); // GeoJSON FeatureCollection
  const [loading, setLoading] = useState(true);

  async function loadData() {
    try {
      const geojson = await fetchLatestBottlenecks();
      setData(geojson);
      setError("");
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    let cancelled = false;

    // First load
    const initialLoad = async () => {
      if (cancelled) return;
      await loadData();
    };

    initialLoad();

    // Auto-refresh every 5 minutes
    const interval = setInterval(() => {
      if (!cancelled) {
        loadData();
      }
    }, REFRESH_INTERVAL);

    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  return (
    <DashboardLayout>
      <MDBox
        sx={{
          position: "relative",
          width: "100%",
          height: "85vh", // Full page height
          m: 0,
          p: 0,
        }}
      >
        {/* Loading overlay */}
        {loading && (
          <MDBox
            sx={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10,
              bgcolor: "rgba(0,0,0,0.1)",
            }}
          >
            <CircularProgress />
          </MDBox>
        )}

        {data && <BottlenecksMap geojson={data} />}
      </MDBox>
    </DashboardLayout>
  );
}

export default Bottlenecks;
